import styled from 'styled-components'

export const TableWrapper = styled.div`
  & table tbody tr {
    height: 70px;
  }

  & table tbody td {
    padding: 16px 12px;
  }
`
